import React from 'react';
import { Image } from '@unpic/react';

interface Props {
  s3Path: string;
  width?: number;
  height?: number;
  alt?: string;
  className?: string;
}

/**
 * width ❌ + height ❌ = full width image, no defined height
 * width ❌ + height ✅ = full width image with limited height
 * width ✅ + height ❌ = fixed width image, no defined height (layout shift is ok in-app)
 * width ✅ + height ✅ = constrained image
 */
export default function Img(props: Props) {
  const { s3Path, width, height, className, alt } = props;

  const separator = s3Path.startsWith('/') ? '' : '/';

  if (!width) {
    return (
      <Image
        src={`${import.meta.env.VITE_IMAGEKIT_URL}${separator}${s3Path}`}
        cdn="imagekit" // force CDN because we use a custom domain
        alt={alt}
        className={className}
        height={height}
        layout="fullWidth"
      />
    );
  }

  return (
    <Image
      src={`${import.meta.env.VITE_IMAGEKIT_URL}/${s3Path}`}
      cdn="imagekit"
      alt={alt}
      className={className}
      width={width}
      height={height as any as number} // force type even if height is undefined
      layout="constrained"
    />
  );
}
